module.exports = __webpack_public_path__ + "static/media/3.a69a6f2e.jpg";